import { Collection } from "@tblabs/truffle";
import { IStorable } from "../Models/IStorable";
import { IStorageUserPrivileges, ObjectDataset } from "@tblabs/storage";


export class Repo<T extends IStorable>
{
    public Items = new Collection<T>();

    constructor(private _storageRepo: ObjectDataset<T>)
    { }

    public CanUser(action: keyof IStorageUserPrivileges): boolean
    {
        return this._storageRepo.CanUserDo(action);
    }

    public async Init(): Promise<void>
    {
        const itemsArray = await this._storageRepo.GetAll();

        this.Items = new Collection(itemsArray.sort((a, b) => +b.CreatedAt - +a.CreatedAt));
    }

    public async Get(id: string): Promise<T>
    {
        const item = await this._storageRepo.GetOne(id);

        if (!item)
        {
            throw new Error(`"$id" not found`);
        }

        return item;
    }

    public async Add(item: T): Promise<void>
    {
        await this._storageRepo.Add(item.Id, item);

        this.Items.Add(item);
    }

    public async Update(item: T): Promise<void>
    {
        await this._storageRepo.Update(item.Id, item);
    }

    public async Delete(item: T): Promise<void>
    {
        await this._storageRepo.Delete(item.Id);

        this.Items.Remove(item);
    }
}
